import styled from "styled-components";

export const Wrapper = styled("main")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: "1 0 auto",
}));

export const MainContent = styled("div")(({ theme }) => ({
  backgroundColor: "rgb(245, 247, 250)",
}));
